import { PreviousAccountOptionsController } from './previousAccountOptions.controller';
import template from './previousAccountOptions.html';

export const confirmWarrantPreviousAccountOptionsComponent = {
  name: 'confirmWarrantPreviousAccountOptions',
  restrict: 'E',
  template,
  controller: PreviousAccountOptionsController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '=',
    translatePrefix: '@',
  },
};
